import { Resource } from 'kolibri/apiResource';

export const SignUpResource = new Resource({
  name: 'signup',
});
